<template>
  <div class="p-grid dashboard">
    <div class="p-col-12">
      <Toast />

      <div class="card">
        <div class="title">Laporan Pendataan Supplier</div>
        <DataTable
          :value="items"
          :paginator="true"
          class="p-datatable-outlets"
          :rows="limit"
          :rowHover="true"
          :scrollable="true"
          :loading="loading"
          :lazy="true"
          :totalRecords="total_record"
          @page="getReportSupplier($event)"
        >
          <template #header>
            <div class="p-grid p-fluid p-mb-2">
              <div class="p-col-2" style="margin-top: 2.2rem">
                <Calendar
                  v-model="start_date"
                  :showIcon="true"
                  dateFormat="yy-mm-dd"
                  placeholder="Start Date"
                  :selectOtherMonths="true"
                  :showButtonBar="true"
                />
              </div>
              <div class="p-col-2" style="margin-top: 2.2rem">
                <Calendar
                  v-model="end_date"
                  :showIcon="true"
                  dateFormat="yy-mm-dd"
                  placeholder="End Date"
                  :selectOtherMonths="true"
                  :showButtonBar="true"
                />
              </div>
              <div class="p-col-2" style="margin-top: 2.2rem">
                <div>
                  <AutoComplete
                    placeholder="Pilih Supplier"
                    id="supplier"
                    :dropdown="true"
                    :multiple="false"
                    v-model="selectedSupplier"
                    :suggestions="autoFiltered"
                    field="name"
                    @complete="searchSupplier($event)"
                    @input="getSupplierReturList()"
                  >
                  </AutoComplete>
                </div>
              </div>
              <div class="p-col-2" style="margin-top: 2.2rem">
                <Button
                  label="Cari"
                  class="p-button-primary"
                  icon="pi pi-search"
                  @click="getReportSupplierFilter()"
                  v-shortkey.push="['enter']"
                  @shortkey="getReportSupplierFilter()"
                />
              </div>
              <div
                class="p-col-2"
                style="margin-top: 2.2rem"
                v-if="items.length >= 1"
              >
                <router-link
                  :to="{
                    name: 'print-supplier-report',
                    query: {
                      start_date: formattedStartDate,
                      end_date: formattedEndDate,
                      page: 1,
                      limit: total_record
                    }
                  }"
                  v-if="items && items.length > 0"
                >
                  <Button
                    label="Print"
                    icon="pi pi-print"
                    class="p-button-success"
                  />
                </router-link>
              </div>
              <div
                class="p-col-2"
                style="margin-top: 2.2rem"
                v-if="items.length >= 1"
              >
                <Button
                  label="Convert to Excel"
                  icon="pi pi-file-excel"
                  class="p-button-secondary"
                  style="color: white"
                  @click="convertToExcel"
                />
              </div>
            </div>
          </template>
          <template #empty>Data tidak ditemukan.</template>
          <template #loading
            >Mengambil data kelompok barang. Mohon tunggu</template
          >
          <Column
            header="Kode Supplier"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.supplier_code }}
              </div>
            </template>
          </Column>
          <Column
            header="Nama Supplier"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.supplier_name }}
              </div>
            </template>
          </Column>
          <Column
            header="Tanggal"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.date }}
              </div>
            </template>
          </Column>
          <Column
            header="Selisih Stock"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.stock | number }}
              </div>
            </template>
          </Column>
          <Column
            header="Qty Masuk"
            headerStyle="text-align: center; width: 12rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.qty_in | number }}
              </div>
            </template>
          </Column>
          <Column
            header="Qty Terjual"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.qty_sell | number }}
              </div>
            </template>
          </Column>
          <Column
            header="Qty Retur"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.qty_retur | number }}
              </div>
            </template>
          </Column>
          <Column
            header="Qty Transfer"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.qty_transfer }}
              </div>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </div>
</template>

<script>
var moment = require('moment')
import * as XLSX from 'xlsx'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['user', 'isAuthenticated']),

    formattedStartDate() {
      return this.formatDate(this.start_date)
    },
    formattedEndDate() {
      return this.formatDate(this.end_date)
    }
  },
  data() {
    return {
      moment: moment,
      loading: true,
      expandedRows: [],
      items: [],
      today: new Date().toISOString().split('T')[0],
      start_date: null,
      end_date: null,
      limit: 10,
      total_record: 0,
      selectedSupplier: { id: '', code: '', name: '' },
      selectedSuppliers: null,
      autoFiltered: []
    }
  },
  mounted() {
    this.getAuthUser()
    this.getReportSupplier()
    this.getListSupplier()
  },
  methods: {
    getAuthUser() {
      console.info(this.user)
      this.start_date = this.today
      this.end_date = this.today
    },

    getListSupplier() {
      this.$http
        .get(`${process.env.VUE_APP_API_URL}/suppliers`)
        .then(response => {
          if (response.status === 200) {
            this.selectedSuppliers = response.data.data.suppliers
          }
        })
    },

    searchSupplier(event) {
      const query = event.query.toLowerCase()
      this.autoFiltered = this.selectedSuppliers.filter(item => {
        const nameMatch = item.name.toLowerCase().includes(query)
        const codeMatch = item.code.toLowerCase().includes(query)
        return nameMatch || codeMatch
      })
    },

    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    convertToExcel() {
      const worksheet = XLSX.utils.json_to_sheet(this.items)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Report')
      XLSX.writeFile(workbook, 'Laporan Pendataan Supplier.xlsx')
    },

    async getReportSupplier(event) {
      let page = 1
      if (event) {
        page = event.page + 1
      }
      this.loading = true
      let start_date = this.start_date
        ? moment(this.start_date).format('YYYY-MM-DD')
        : this.today
      let end_date = this.end_date
        ? moment(this.end_date).format('YYYY-MM-DD')
        : this.today

      let sup_id = ''
      if (this.selectedSupplier != null) {
        sup_id = this.selectedSupplier.code ? this.selectedSupplier.code : ''
      }

      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/supplier_report?start_date=${start_date}&end_date=${end_date}&page=${page}&limit=${this.limit}&search=${sup_id}`
        )
        if (response.status === 200) {
          this.items = response.data.data.supplier_data
          this.total_record = response.data.total
        } else {
          this.showToast('error', 'Error', 'Gagal mengambil data')
        }
      } catch (error) {
        this.showToast(
          'error',
          'Error',
          'Terjadi kesalahan saat mengambil data'
        )
        console.error('Error fetching report refund:', error)
      } finally {
        this.loading = false
      }
    },

    getReportSupplierFilter() {
      this.loading = true
      if (this.end_date < this.start_date) {
        this.showToast('error', 'Error', 'Gagal mengambil data')
        this.loading = false
        this.start_date = this.today
        this.end_date = this.today
      } else {
        this.getReportSupplier()
      }
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;

  .p-progressbar-value {
    background-color: #607d8b;
  }
}

.qty {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 50px;
}

.p-datatable .p-column-filter {
  display: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

/deep/ .p-datatable.p-datatable-outlets {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

/* Responsive */
.p-datatable-outlets .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }

  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }

  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }

  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}

.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}

@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}

.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.orders-subtable {
  padding: 1rem;
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}

.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }

  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }

  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }

  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}

@media screen and (max-width: 960px) {
  /deep/ .p-datatable {
    &.p-datatable-outlets {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr {
        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;
          border: 0 none;

          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }

          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}
::v-deep(.p-datatable table) {
  border-collapse: collapse;
}

::v-deep(.p-datatable th),
::v-deep(.p-datatable td) {
  border: 1px solid #ccc !important;
  padding: 8px;
}
</style>
